/**
 * The layout route the Home page is a child of. Named so an extension's Home can be put in its place
 * (see setHomePage in shell/core/plugin.ts).
 */
export const HOME_LAYOUT = 'home-layout';
